.root {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  width: 100%;
}

.columnLabels {
  display: flex;
  justify-content: space-around;
  font-weight: 600;
  font-size: var(--tuna-typography-body1-fontSize);
  color: var(--tuna-content-primary);
}

.svg {
  width: 100%;
  height: 12rem;
  background: var(--tuna-surface-elevated, var(--tuna-palette-grey-100));
  border-radius: var(--tuna-shape-borderRadius);
  border: 1px solid var(--tuna-border-subtle, var(--tuna-palette-grey-300));
}

/*
 * Three distinct lane fills so Bass / Middle / Top read apart at a glance
 * (the 3rd-on-top vs 5th-on-top pedagogical hook). The earlier info-300/500/700
 * tokens do not exist in the theme, so bass and mid both collapsed to info-main
 * — making two of the three voices identical. Use the real teal ramp instead.
 */
.voiceBass rect {
  fill: var(--tuna-palette-info-light);
}

.voiceMid rect {
  fill: var(--tuna-palette-info-main);
}

.voiceTop rect {
  fill: var(--tuna-palette-info-dark);
}

/*
 * WCAG 1.4.1: the three motion types must be distinguishable without colour, so
 * each carries a distinct stroke pattern in addition to hue:
 *   held  → solid       step → dotted        leap → dashed
 */
.commonToneHeld {
  stroke: var(--tuna-feedback-success, var(--tuna-palette-success-main));
  stroke-width: 2;
}

.step {
  stroke: var(--tuna-content-secondary);
  stroke-width: 1.5;
  stroke-dasharray: 1 2;
  stroke-linecap: round;
}

.leap {
  stroke: var(--tuna-feedback-warning, var(--tuna-palette-warning-main));
  stroke-width: 1.5;
  stroke-dasharray: 3 2;
}

/* Shared pitch reference so a viewer can read that, e.g., the top voice rises A→B. */
.gridline {
  stroke: var(--tuna-border-subtle, var(--tuna-palette-grey-300));
  stroke-width: 0.5;
  opacity: 0.5;
}

/* ───── Parallel perfect 5th/8va highlight (classical only) ───── */
.parallelSpan {
  pointer-events: none;
}

.parallelBracket {
  stroke: var(--tuna-feedback-warning, var(--tuna-palette-warning-main));
  stroke-width: 1.5;
}

.parallelTie {
  stroke: var(--tuna-feedback-warning, var(--tuna-palette-warning-main));
  stroke-width: 1;
  stroke-dasharray: 2 2;
  opacity: 0.7;
}

.parallelGlyph {
  fill: var(--tuna-feedback-warning, var(--tuna-palette-warning-main));
  font-size: 7px; /* tuna-allow: svg geometry */
  font-weight: 700;
  paint-order: stroke;
  stroke: var(--tuna-surface-elevated, var(--tuna-palette-grey-100));
  stroke-width: 1.5;
}

/* ───── Motion legend ───── */
.legend {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-2);
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
}

.legendItem {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
}

.legendSwatch {
  width: 1.5rem;
  height: 0.5rem;
  flex: none;
}

.columns {
  display: flex;
  justify-content: space-around;
  font-family: var(--tuna-typography-mono-fontFamily, monospace);
  font-size: var(--tuna-typography-body2-fontSize);
}

.column {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: var(--tuna-spacing-1);
  color: var(--tuna-content-secondary);
}

.empty {
  color: var(--tuna-content-muted);
  font-size: var(--tuna-typography-body2-fontSize);
  padding: var(--tuna-spacing-2);
}
